"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ptLocaleData = require("i18next-icu/locale-data/pt");
exports.default = ptLocaleData;
//# sourceMappingURL=pt.js.map